import React from 'react';
import lang from '../../Lang/lang.json';

let BackupImgSel = (props) => {
  let {years, months, getDate, deleteOriginal, language, createImgBkup} = props;
  return (
    <div className="backupImg_create">
      <select onChange={getDate("year")}>
        <option>Elige el año</option>
      { years
        ?years.map((year, key) => (
          <option key={key} value={year}>{year}</option>
        ))
        : "cargando"
      }
      </select>
      <select onChange={getDate("month")}>
        <option>Elige el mes</option>
      {
        months
        ?months.map((month, key) => (
          <option key={key} value={month}>{month}</option>
        ))
        : "Elige un año"
      }
      </select>
      <div className="outline-butn green" onClick={() => createImgBkup()}>{lang.BackupDB.create[language]}</div>
      <div className="outline-butn red" onClick={() => deleteOriginal()}>Borrar original</div>
    </div>
  )
}
export default BackupImgSel;


// WEBPACK FOOTER //
// ./src/Components/Admin/Backup/BackupImgSel.js